<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />
<div class="k-overlay" *ngIf="addWinOpen"></div>

<ng-template #windowTitleBar let-win>
  <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
    </span> {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>

<div class="container" my-5>
  <div class="card" #appendTo>
    <div class="card-body no-border">

      <kendo-grid [kendoGridBinding]="gridData" [loading]="dataService.loading" [groupable]="true" [resizable]="true" style="max-height: 450px;">


        <ng-template kendoGridToolbarTemplate position="top">
          <button [hidden]="!canCreate" (click)="addLabel(windowTitleBar)" kendoButton class="btn btn-primary">
            <fa-icon icon="circle-plus"></fa-icon> Add Label
          </button>
        </ng-template>

        <kendo-grid-column title="Edit" [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button [hidden]="!canUpdate" (click)="editLabel(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="edit"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="project_label_description" title="Description" [width]="200">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Activate/Deactivate" [width]="80" >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <input type="checkbox" kendoCheckBox size="large" [checked]="dataItem.active"
                   (click)="setActive(dataItem)" />
          </ng-template>
        </kendo-grid-column>


      </kendo-grid>

      <div class="d-grid d-md-flex justify-content-md-end">
        <button type="button" class="btn btn-primary me-md-2" (click)="closeWindow()"> Close</button>
      </div>

    </div>
  </div>

</div>
